import React, { useState, useEffect } from 'react';
import styles from './css/CityFilesPage.module.css';
import { Tab } from '@/types';
import { useTranslation } from 'react-i18next';
import GeneralTabs from '@/components/tabs/GeneralTabs';
import CityFilesTable from '@/components/tables/CityFilesTable';
import { files } from '@/mocks/files';
import { FileData, SelectedFiles } from '@/types';
import { DocView } from '@/components/files/DocView';

const CityFilesPage: React.FC = () => {
    const { t } = useTranslation('CityFilesPage');
    const [activeTab, setActiveTab] = useState<string>("outlinePlans");
    const [stateFiles, setStateFiles] = useState<FileData[]>(files);
    const [showFile, setShowFile] = useState<FileData>();
    const [selectedFiles, setSelectedFiles] = useState<SelectedFiles[]>([]);
    const [selectAll, setSelectAll] = useState<boolean>(false);
    const tabs: Tab[] = [
        {
            name: t("outlinePlans"),
            key: "outlinePlans"
        },
        {
            name: t("municipalBuildingPlans"),
            key: "municipalBuildingPlans"
        }
      ]

    const handleSelectAll = (selectAll: boolean) => {
        const newStateFiles = selectAll ? files.map(file => ({ 
            ...file, 
            selected: true
        })) : files.map(file => ({ 
            ...file, 
            selected: false
        }));
        setStateFiles(newStateFiles);
        setSelectAll(selectAll);
        setSelectedFiles(newStateFiles.filter(file => file.selected));
    }

    const handleCheckboxToggle = (fileId: string) => {
        const newStateFiles = stateFiles.map(file => file.id === fileId ? { 
            ...file, 
            selected: !file.selected
        } : file);
        const allFilesSelected = newStateFiles.every(file => file.selected);
        setSelectAll(allFilesSelected);
        setStateFiles(newStateFiles);
        setSelectedFiles(newStateFiles.filter(file => file.selected));
    }

    const setSelectedShowFiles = (id: string) => {
        // TODO get the file for the url
        setShowFile(stateFiles.find(file => file.id === id));
    }

    function downloadPDF(pdfUrl: string, filename: string) {
        const a = document.createElement("a");
        a.href = pdfUrl;
        a.download = filename;
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

  return (
    <div className={styles.container}>
      <div className={styles.tabs}>
        <GeneralTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
      </div>
      <div className={styles.row}>
            <div className={styles.tableContainer}>
                <CityFilesTable 
                    files={stateFiles}
                    setSelectedShowFiles={setSelectedShowFiles}
                    handleSelectAll={handleSelectAll}
                    onCheckboxToggle={handleCheckboxToggle}
                    checkedFiles={selectedFiles}
                    isSelected={selectAll}
                    dataTestId="city-files-table"
                    selectedFileId={showFile?.id}
                    downloadPDF={downloadPDF}
                />
            </div>
            <div className={styles.fileContainer}>
                {showFile && <DocView file={showFile}/>}
            </div>
        </div>
    </div>
  );
};

export default CityFilesPage;
